import BvAnimated from 'volta/components/bv-animated';
import BvFlash from 'volta/components/bv-flash';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import AnimatedEach from 'ember-animated/components/animated-each';

import type BvFlashService from 'volta/services/bv-flash';

interface BvFlashContainerSignature {
  Args: { position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' };
  Element: HTMLDivElement;
}

export default class BvFlashContainerComponent extends Component<BvFlashContainerSignature> {
  <template>
    <div class='bv-flash-container' ...attributes>
      <BvAnimated
        @contained={{true}}
        class='u-full-width u-d-flex u-align-items-end u-flex-column'
        as |animated|
      >
        {{#AnimatedEach
          this.bvFlash.queue key='id' use=animated.verticalList duration=200
          as |flash|
        }}
          <BvFlash @flash={{flash}} />
        {{/AnimatedEach}}
      </BvAnimated>
    </div>
  </template>
  @service declare bvFlash: BvFlashService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvFlashContainer: typeof BvFlashContainerComponent;
    'bv-flash-container': typeof BvFlashContainerComponent;
  }
}
